// @flow
import React from 'react';
import { compose } from 'recompose';
import { translate, type TFunction } from 'react-i18next';
import { themr, type ThemeType } from 'react-css-themr';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { List } from 'immutable';

import { Flex, Tooltip } from '@locus-taxy/neo-ui';
import { MenuItem } from 'common/components/core/menu';
import { ContextMenuFactory } from 'common/components/core/context_menu/ContextMenu';
import theme from './FpPlanContextMenu.scss';

import type { ContainerType } from 'common/enums/PlanFilterEnum';
import { TourSummaries } from 'common/models/internal/PlanSummary';
import { AllocatedTasks } from 'common/models/internal/PlanAllocated';
import {
    withVisitStates,
    type TourVisitIdentifierType
} from 'common/contexts/VisitStateContext';

type State = {
    isOpen: boolean
};

type OwnProps = {
    getContainer: () => ContainerType,
    theme: ThemeType,
    value: string,
    type: string,
    caption: string,
    onClick?: () => void,
    closeContextMenu?: () => void,
    getExtraContainer: () => ?Object,
    getExtraContainerRef: () => ?Object
};

type Props = {
    ...OwnProps,
    selectedVisits: List<TourVisitIdentifierType>,
    tourSummariesList: Array<TourSummaries>,
    tourTasks: List<AllocatedTasks>,
    t: TFunction,
    disabled: boolean,
    tooltip: string
};
class FpCustomMenuItem extends React.Component<Props, State> {
    state = { isOpen: false };

    onTogglePopup = (isOpen: boolean) => {
        this.setState({
            isOpen
        });
        if (!isOpen) {
            const { closeContextMenu } = this.props;
            closeContextMenu?.();
        }
    };

    handleClick = (...args) => {
        const { closeContextMenu, onClick } = this.props;
        closeContextMenu?.();
        onClick?.(...args);
    };

    showPopup = () => {
        this.setState(prevState => {
            return { isOpen: !prevState.isOpen };
        });
    };

    handleOutsideClick = () => {
        this.setState({
            isOpen: false
        });
    };

    render() {
        const {
            theme,
            value,
            caption,
            onClick,
            disabled,
            tooltip
        } = this.props;
        return (
            <Tooltip tooltip={tooltip}>
                <Flex alignItems="center" width={80} height={25}>
                    <MenuItem
                        theme={theme}
                        value={value}
                        caption={caption}
                        onClick={onClick}
                        disabled={disabled}
                    />
                </Flex>
            </Tooltip>
        );
    }
}

//Making a container of it, because TimeLineRow is memoized and hence the details are not passed down

const FpComposedMenuItem = withVisitStates(['selectedVisits'])(
    compose(withRouter, connect())(FpCustomMenuItem)
);

const FpCustomContextMenu = ContextMenuFactory({
    MenuItemComponent: FpComposedMenuItem
});

export default compose(
    themr('FpPlanContextMenu', theme),
    translate('entityManagement')
)(FpCustomContextMenu);

export { FpCustomMenuItem };
